import { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { usePage } from '@inertiajs/react'
import { DirectUpload } from '@rails/activestorage';

export default function Dropzone({
  onUploaded,
  label,
  accept,
  helpText = '',
  maxFiles = 1,
  maxSize
}) {
  const { directUploadsUrl } = usePage().props;
  const [uploading, setUploading] = useState(false);

  const uploadFile = useCallback((file) => new Promise((resolve, reject) => {
    const upload = new DirectUpload(file, directUploadsUrl)
    upload.create((error, blob) => (error ? reject(error) : resolve(blob)));
  }, [directUploadsUrl]));

  const onDrop = useCallback(async (acceptedFiles) => {
    try {
      setUploading(true);
      const blobs = await Promise.all(acceptedFiles.map(file => uploadFile(file)));
      await onUploaded(blobs);
    } catch (error) {
      console.error('文件上传错误:', error);
    } finally {
      setUploading(false);
    }
  }, [onUploaded]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxFiles,
    maxSize,
    accept
  });

  return (
    <div>
      <div
        {...getRootProps()}
        className={`border-2 border-dashed rounded-lg p-6 text-center ${
          isDragActive ? 'border-blue-500 bg-blue-50' : 'border-gray-300'
        } ${uploading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
      >
        <input {...getInputProps()} disabled={uploading} />
        <div className="mb-3">
          <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
            <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4h-8m-12 0H8a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <p className="mt-1 text-sm text-gray-600">
            {uploading ? '正在上传...' : (
              <>
                将文件拖放到此处或
                <button className="text-blue-500 hover:text-blue-700 font-medium mx-1">
                  浏览文件
                </button>
                {label}
              </>
            )}
          </p>
          <p className="text-xs text-gray-500 mt-1">
            {helpText}
          </p>
        </div>
      </div>
    </div>
  );
}
